import ApplicationSerializer from "./application";

export default class DnssecRecordSerializer extends ApplicationSerializer {
  usesProxy = true;

  attrs = {
    domain: { serialize: false },
    algorithmname: { serialize: false },
    digesttype: { serialize: false },
    digesttypename: { serialize: false },
    digest: { serialize: false },
    keytag: { serialize: false },
    status: { serialize: false },
    origin: { serialize: false },
    createdat: { serialize: false },
  };

  normalizeCreateRecordResponse(store, primaryModelClass, payload, id, requestType) {
    const response = payload.response ?? payload;
    const record = response.record;

    return this.normalizeSingleResponse(
      store,
      primaryModelClass,
      {
        "dnssec-record": {
          domain: response.domainname,
          ...record,
        },
      },
      id,
      requestType,
    );
  }
}
